import { Outlet, useNavigate } from "react-router-dom";
import RCALayout from "./components/RCALayout";
import { RCASettingsContextProvider } from "contexts/RCASettingsContext.ts/RCASettingsContextProvider";
import { useContext, useEffect, useState } from "react";
import { CorporateContext } from "contexts/CorporateContext/CorporateContext";
import { useTranslation } from "react-i18next";
import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";

const RCA = () => {
    const { rcaEnabled } = useContext(CorporateContext);
    const [isCheckingAccessToRca, setIsCheckingAccessToRca] = useState<boolean>(true);
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (isCheckingAccessToRca) {
            if (rcaEnabled !== undefined) {
                if (!rcaEnabled) {
                    navigate(CORPORATE_BACKOFFICE_PATHS.CORPORATE_DASHBOARD);
                } else {
                    setIsCheckingAccessToRca(false);
                }
            }
        }
    }, [isCheckingAccessToRca, navigate, rcaEnabled]);

    if (isCheckingAccessToRca) {
        return (
            <RCALayout>
                <div>{t("corporate_dashboard.checking_access")}</div>
            </RCALayout>
        );
    }

    return (
        <RCASettingsContextProvider>
            <RCALayout>
                <Outlet />
            </RCALayout>
        </RCASettingsContextProvider>
    );
};

export default RCA;
